// Module
import React from 'react';
import { BrowserRouter } from 'react-router-dom';

// Component
import ScrollTop from 'User/Component/ScrollTop';
import App from './App';


const Root = () => {  
  return (
    <BrowserRouter>
      <ScrollTop />
      <App/>
    </BrowserRouter>
  )
}

export default Root;